exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error {\n  border-color: rgba(255,89,90, 0.8 );\n  background: rgba(255,89,90, 0.4 ); \n}\n.helper {\n  font-size: 18px;\n  color:rgb(1, 30, 65,);\n  vertical-align: top;\n}\n.wrong {\n  border-color: rgba(255,89,90, 0.8 );\n  background: rgba(255,89,90, 0.4 ); \n}\n.glyphicon {\n  font-size: 10px;\n  color:rgb(1, 30, 65,);\n}\n.glyphicon-question-sign {\n  font-size: 16px;\n  color:rgb(1, 30, 65,);\n}\n/* datum - centrirati */\n/* .place-date {\n  margin-top: 40px;\n  vertical-align: middle;\n  text-align: center;\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/milic/self-legal/src/app/contract-input/contract-input.component.css
// module id = ../../../../../src/app/contract-input/contract-input.component.css
// module chunks = main